const lbaCountrySelect = angular.module('app.lbaCountrySelect', []);

lbaCountrySelect.controller('lbaCountrySelectCtrl', require('./lbaCountrySelectCtrl'));
lbaCountrySelect.directive('lbaCountrySelect', require('./lbaCountrySelectDir'));
lbaCountrySelect.service('countriesService', require('../../services/countriesService'));

export default lbaCountrySelect;



// WEBPACK FOOTER //
// ./src/components/lbaCountrySelect/index.js